module.exports = require('communities-universal/lib/constants/appsConfig');



// WEBPACK FOOTER //
// ./app/constants/applications.js